import { Component } from "@angular/core";
import { DataService } from "../../services/data.service";
import { BusinesLogicService } from "../../services/business-logic.service";
import { ModalHelper } from "../../components/modal/modal.helper";
import { NotificationService } from "../../services/notification.service";
import { LanguagePipe } from "../../services/language.pipe";
import { DeskMessage } from "../../models/deskmessage.model";
import { Subscription } from 'rxjs/Subscription';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ChatService } from "../../services/chat.service";

declare var $: any;


@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.css"]
})
export class MessageComponent {
  public chatDesks: any; /* Mesas con chat activado */
  public alertDesks: any; /* Mesas con botón de emergencia activado */
  public status: number = 0; /* 0 = Enviar, 1 = Enviando..., 2 = Enviado */
  public messageForm: object;
  public notifyCounter: number = 0;
  public ioConnection: any;
  public messages: object[] = [];
  public alerts: object[] = [];
  public messagesAlert: object[] = [];
  public message: object = {};
  private subscriptionClose: Subscription;
  private subscriptionOpen: Subscription;
  private loadingSocket: boolean = false;

  public actualConversation: object = null;
  public actualConversationMessages: object[] = [];
  public conversations: any[] = [];

  public showGlobalMessages: boolean = false;
  public globalMessageOffices: Array<object> = [];
  public globalMessageOfficeSelected: number = null;
  public globalMessageDesks: Array<object> = [];
  public globalMessage: string = "";
  public globalMessageOk: boolean = false;

  private destroy$ = new Subject();

  constructor(
    public _data: DataService,
    private _blogic: BusinesLogicService,
    private _notify: NotificationService,
    private _lang: LanguagePipe,
    public _modal: ModalHelper,
    private _chat: ChatService
  ) { }

  ngOnInit() {
    this.parseDesks(); /* Parseo de mesas con el chat activado */
    this.parseDesks(
      "alert"
    ); /* Parseo de mesas con el botón de emergencia activado */

    this.initIoConnection();

    this.globalMessageOfficeSelected = this._data.session["office"];
    this.globalMessageOffices = this._data.offices;
    this.getGlobalMessageDesks();

    this._blogic.getOnlineList();

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  // Initialize SocketConnection
  private initIoConnection(): void {
    if (!this.loadingSocket) {
      this.loadingSocket = true;
      if (this.subscriptionClose != null)
        this.subscriptionClose.unsubscribe();
      if (this.subscriptionOpen != null)
        this.subscriptionOpen.unsubscribe();
      if (this.ioConnection != null)
        this.ioConnection.unsubscribe();

      this._chat.close();

      this._chat.open();
      this.ioConnection = this._chat.onMessage()
        .subscribe((message: DeskMessage) => {

          if (message.type == "alert") {
            if (message["from"] != this._data.session["desk"]) {
              this.alerts.push(message);
              this.messages.push(message);
              this.notify();
            }
          } else {

            if (message.to != 'all') {

              if (message.msg == "readed!246810readed!") {
                this.markConversationAsRead(message.from);
              } else {
                this.conversations.push({ chatWith: message.from, msg: message.msg, hour: this.getTime(), messageByMe: false, readed: false, readedByMe: false });
                this.getConversation(message.from, false);
                this.messages.push(message);

                this.notify();

                if (this.actualConversation != null && message.from == this.actualConversation["id"]) {
                  this.send(false, true);
                  this.markConversationAsRead(this.actualConversation["id"]);
                  this.markMyNotificationsAsRead(this.actualConversation["id"]);
                }
              }

            }
            else {
              this.messagesAlert.push(message);

              if (this.notifyCounter == 0)
                this.notifyAlarm();

            }
          }
        });

      this.subscriptionOpen = this._chat.onOpen()
        .subscribe((response: any) => {
          this.loadingSocket = false;
        });


      this.subscriptionClose = this._chat.onClose()
        .subscribe((response: any) => {

          setTimeout(() => {
            this._chat.close();
            this.loadingSocket = false;
            this.initIoConnection();
          }, 15000);
        });
    }
  }

  /* Open the messages modal */
  public openSendModal(from: number = null, content: string = null): void {
    if (from != null && content != null) {
      this.messageForm["to"] = from;
      this.messageForm["content"] = content;
      //this.markAsRead();
    } else {
      this.messageForm = {};
    }
    this._blogic.deskOnline()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.onlineDesks = response;
          this._modal.show("sendModal");

          let self = this;
          $('#sendModal').on('hidden.bs.modal', function (e) {
            self.actualConversation = null;
          })
        });
  }

  public lastMessage(id) {
    let lastMessage = null;
    this.conversations.forEach(e => {
      if (id == e.chatWith)
        lastMessage = e;
    });

    return lastMessage;
  }

  public openAlertModal(): void {
    this._modal.show("questionAlertModal");
  }

  public getCountNotifications(id) {
    let count = 0;
    this.conversations.forEach(e => {
      if ((id == e.chatWith) && (e.messageByMe == false) && (e.readedByMe == false)) {
        count++;
      }
    })

    return count;
  }

  public getCountAllNotifications() {
    let count = 0;
    this.conversations.forEach(e => {
      if ((e.messageByMe == false) && (e.readedByMe == false)) {
        count++;
      }
    })

    count = count + this.alerts.length;

    return count;
  }

  public deleteAlert(i) {
    this.alerts.splice(i, 1);
  }

  public parseDesks(mode: string = "chat") {
    let desks = [];

    this._blogic.getChatList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        this._data.desks.forEach(e => {

          if (mode == "chat") {
            if (response.chat.indexOf(e.id) != -1 && e.id != this._data.session["desk"]) {
              desks.push(e);
            }
          } else {
            if (response.alert.indexOf(e.id) != -1 && e.id != this._data.session["desk"]) {
              desks.push(e);
            }
          }

        });
      });

    if (mode == "chat") {
      this.chatDesks = desks;
    } else {
      this.alertDesks = desks;
    }
  }

  public getDesksAvailables() {
    let availableDesks: object[] = [];
    this.chatDesks.forEach(e => {
      if (this._blogic.isDeskOnline(e.id))
        availableDesks.push(e);
    });

    availableDesks = availableDesks.sort(function (a, b) {
      return a["id"] - b["id"];
    });

    return availableDesks;

  }

  public send(alert: boolean = false, readedAlert: boolean = false) {
    if ((this.messageForm && this.messageForm["content"] && this.messageForm["content"].replace(/ /g, "").length > 0) || readedAlert == true || alert) {
      this.status = 1;
      this.message = new DeskMessage();
      if (alert) {
        this.message["to"] = 'all';
        this.message["msg"] = this._data.configuration["alertMessage"];
      }
      else {
        this.message["to"] = this.actualConversation["id"];
        this.message["msg"] = this.messageForm["content"];

        if (!readedAlert) {
          this.conversations.push({ chatWith: this.actualConversation["id"], msg: this.message["msg"], hour: this.getTime(), messageByMe: true, readed: false, readedByMe: true });
          this.getConversation(this.actualConversation["id"]);
        }
      }

      this.message["from"] = this._data.session["desk"];
      this.message["from_name"] = this._data.session["deskname"];

      if (readedAlert)
        this.message["msg"] = "readed!246810readed!";

      this._chat.sendMessage(this.message);
      if (!readedAlert)
        this.messageForm = {};
      this.status = 2;
      setTimeout(() => {
        this.status = 0;
        if (alert)
          this._modal.hide("questionAlertModal");
      }, 1500);
    }
  }

  public sendGlobalMessage() {

    this.globalMessageDesks.forEach(e => {
      if (e["checked"] == true) {
        var message = new DeskMessage();
        message["to"] = e["id"];
        message["msg"] = this.globalMessage;
        message["from"] = this._data.session["desk"];
        message["from_name"] = this._data.session["deskname"];
        message["office_name"] = this._data.session["officename"];
        message["hour"] = this.getTime();
        message["type"] = "alert";

        this._chat.sendMessage(message);
        this.globalMessageOk = true;

        setTimeout(() => {
          this.globalMessageOk = false;
        }, 2000);

      }
    })

    this.globalMessage = "";
  }

  public getConversation(id, showInView = true) {
    if (id == null)
      return;

    let conversation = [];
    this.conversations.forEach(e => {
      if (e.chatWith == id) {
        conversation.push(e);
      }
    });

    if (this.actualConversation && this.actualConversation["id"] == id)
      this.actualConversationMessages = conversation;
    setTimeout(() => {
      var d = $('#chat-view');
      d.scrollTop(d.prop("scrollHeight"));
    }, 50);
  }

  // Envía que he leído la conversación actual
  public readConversation() {
    this.send(false, true);
  }

  public sendAlert(): void {
    this.send(true);
  }

  public notifyAlarm() {
    this.message = this.messagesAlert.shift();
    $(".modal").modal("hide");
    this._modal.show("receivedModal", false);
    if (this._notify.hasPermission() && this.notifyCounter == 0) {
      this._notify.notify(
        this._lang.transform("notifyEmergency") +
        this.message["from"],
        this.message["msg"],
        "alarm.gif"
      );
    }
    this.notifyCounter++;
  }

  public notify() {
    this.message = this.messages.shift();
    if (this._notify.hasPermission()) {
      this._notify.notify(
        this._lang.transform("notifyNewMessage") +
        this.message["from_name"],
        this.message["msg"],
        "chat_notification.png"
      );
    }
  }

  public markConversationAsRead(id) {
    this.conversations.forEach(e => {
      if (e.chatWith == id) {
        e.readed = true;
      }
    });
  }

  public markMyNotificationsAsRead(id) {
    this.conversations.forEach(e => {
      if (e.chatWith == id) {
        e.readedByMe = true;
      }
    });
  }

  public markAsRead(): void {
    this._modal.hide("receivedModal");
    this.notifyCounter = 0;

    if (this.messagesAlert.length > 0)
      this.notifyAlarm();
    else if (this.messages.length > 0)
      this.notify();
  }

  public openConversation(d) {
    this.actualConversation = d;
    this.getConversation(d.id);
    //this.markConversationAsRead(d.id); // Envío a la otra persona que he leído sus mensajes
    this.markMyNotificationsAsRead(d.id); // Indico como leída la conversación para que no me aparezca como notificación
    this.readConversation();
  }

  public checkTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  public getTime() {
    var today = new Date();
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    // add a zero in front of numbers<10
    m = this.checkTime(m);
    s = this.checkTime(s);
    return h + ":" + m;
  }

  public getGlobalMessageDesks() {
    this._blogic.listDesk({ office_id: this.globalMessageOfficeSelected })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.globalMessageDesks = response.filter(e => e.visible == true);
          this.globalMessageDesks.map(e => e["checked"] = true);
        }
      );
  }

  public checkAllGlobalDesks() {
    this.globalMessageDesks.map(e => e["checked"] = true)
  }

  public unCheckAllGlobalDesks() {
    this.globalMessageDesks.map(e => e["checked"] = false)
  }
}
